import styled from 'styled-components';
import CancelHeaderSvg from '../../assets/mytrips/ic-cancel.svg';

const CancelHeaderIcon = styled(CancelHeaderSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '6rem'};
  height: ${props => props.height || '6rem'};
  margin: ${props => props.margin};
`;

export default CancelHeaderIcon;
